import React from 'react'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css';

const ToolTipText = ({ value, place = 'top' }) => {
    return (
        <>
            <span data-tooltip-id={value}
                data-tooltip-content={value}>
                {value || ""}
            </span>
            <Tooltip id={value} place={place} className="custom-tooltip" />
        </>
    )
}

export default ToolTipText